<template>
  <v-btn
    flat
    icon
    color="white"
    @click="share">
    <fa-icon
      :icon="['fab', 'facebook-f']"
      fixed-width
      size="lg"
      style="color: #3b5999" />
  </v-btn>
</template>

<script>
export default {
  methods: {
    share() {
      this.$FB.share(window.location.href);
    },
  },
};
</script>
